// import { FiMapPin, FiCompass, FiUsers, FiAward } from "react-icons/fi";
// import { FaHandshake } from "react-icons/fa";
// import GlobalPresence from "./GlobalPresence.jsx";
// import GlobalPartners from "./GlobalPartners.jsx";

// const partners = [
//   "Chambers of Commerce — UK, Germany, France, Italy",
//   "Industry Federations — Japan, South Korea, Singapore",
//   "Business Councils — UAE, Saudi Arabia, Qatar",
//   "Trade Bodies — USA, Canada, Australia",
//   "African Chambers — Nigeria, South Africa, Kenya",
//   "Latin American Councils — Brazil, Mexico, Colombia",
// ];

// const reach = [
//   { label: "Europe", val: "28+ Countries" },
//   { label: "Asia Pacific", val: "18+ Countries" },
//   { label: "Middle East", val: "12+ Countries" },
//   { label: "Africa", val: "22+ Countries" },
//   { label: "Americas", val: "16+ Countries" },
// ];

// const pillars = [
//   { icon: <FiUsers />, title: "Trade Missions", desc: "Inbound and outbound delegations connecting Indian industry with global decision-makers and buyers." },
//   { icon: <FaHandshake />, title: "B2G Engagement", desc: "Direct dialogue with governments and regulators to shape favorable trade and investment policies." },
//   { icon: <FiAward />, title: "Investment Forums", desc: "High-level forums that match Indian enterprises with international capital and strategic partners." },
// ];

// export default function InternationalOutreach() {
//   return (
//     <section id="outreach" className="scroll-mt-28 space-y-16">
//       <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#DB6400] to-[#F59C00] px-8 py-14 md:px-16 md:py-20 shadow-2xl shadow-[#DB6400]/20">
//         <div className="absolute -left-16 -top-16 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
//         <div className="absolute -right-20 -bottom-16 h-60 w-60 rounded-full bg-white/10 blur-2xl" />
//         <div className="relative z-10 max-w-4xl">
//           <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-sm font-medium text-white backdrop-blur-md border border-white/10">
//             <FiMapPin className="h-4 w-4" /> Global Network
//           </div>
//           <h2 className="font-['Cormorant_Garamond'] text-5xl md:text-7xl font-semibold text-white leading-[0.95] tracking-tight">
//             International <span className="italic font-normal">Outreach</span>
//           </h2>
//           <p className="mt-6 max-w-2xl text-lg text-white/90 leading-relaxed font-light">
//             Expanding India's economic footprint through strategic partnerships, trade missions, and institutional collaborations across continents.
//           </p>
//         </div>
//       </div>

//       <GlobalPresence />

//       <div className="grid gap-6 md:grid-cols-3">
//         {pillars.map((card) => (
//           <div key={card.title} className="rounded-3xl bg-white border border-[#FEF7F4] p-8 shadow-xl shadow-black/[0.03] hover:-translate-y-1 hover:shadow-2xl transition-all duration-300 group">
//             <div className="mb-5 h-14 w-14 rounded-2xl bg-gradient-to-br from-[#DA2128] to-[#DB2628] text-white flex items-center justify-center text-xl shadow-lg shadow-[#DA2128]/25 group-hover:scale-110 transition-transform">
//               {card.icon}
//             </div>
//             <h4 className="text-xl font-semibold text-[#1a1a2e] mb-3 font-['Outfit']">{card.title}</h4>
//             <p className="text-[#6a6a7a] leading-relaxed">{card.desc}</p>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// }




// new new code 






import { FiMapPin, FiUsers, FiAward, FiGlobe } from "react-icons/fi";
import { FaHandshake } from "react-icons/fa";
import GlobalPresence from "./GlobalPresence.jsx";

const reach = [
  { label: "Europe", val: "28+ Countries" },
  { label: "Asia Pacific", val: "18+ Countries" },
  { label: "Middle East", val: "12+ Countries" },
  { label: "Africa", val: "22+ Countries" },
  { label: "Americas", val: "16+ Countries" },
];

const partners = [
  { region: "Europe", detail: "Chambers of Commerce — UK, Germany, France, Italy" },
  { region: "Asia Pacific", detail: "Industry Federations — Japan, South Korea, Singapore" },
  { region: "Middle East", detail: "Business Councils — UAE, Saudi Arabia, Qatar" },
  { region: "Americas", detail: "Trade Bodies — USA, Canada, Australia" },
  { region: "Africa", detail: "African Chambers — Nigeria, South Africa, Kenya" },
  { region: "Latin America", detail: "Latin American Councils — Brazil, Mexico, Colombia" },
];

const pillars = [
  { 
    icon: <FiUsers />, 
    title: "Trade Missions", 
    desc: "Inbound and outbound delegations connecting Indian industry with global decision-makers and buyers." 
  },
  { 
    icon: <FaHandshake />, 
    title: "B2G Engagement", 
    desc: "Direct dialogue with governments and regulators to shape favorable trade and investment policies." 
  },
  { 
    icon: <FiAward />, 
    title: "Investment Forums", 
    desc: "High-level forums that match Indian enterprises with international capital and strategic partners." 
  },
];

export default function InternationalOutreach() {
  return (
    <section id="outreach" className="scroll-mt-28 space-y-12">
      
      {/* --- HERO BANNER (CLEAN & SUBTLE) --- */}
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-[#DB6400] via-[#E27012] to-[#F59C00] p-6 md:p-10 text-white shadow-lg">
        
        {/* Soft Ambient Background Blur */}
        <div className="absolute -right-12 -top-12 h-56 w-56 rounded-full bg-white/10 blur-2xl pointer-events-none" />

        <div className="relative z-10 max-w-3xl space-y-4">
          
          {/* Subtle Tag */}
          <div className="inline-flex items-center gap-1.5 rounded-full bg-white/15 px-3 py-1 text-xs font-medium text-white/95 backdrop-blur-sm border border-white/10">
            <FiMapPin className="h-3.5 w-3.5 opacity-90" />
            <span>Global Network</span>
          </div>

          {/* Clean Heading */}
          <h2 className="font-['Outfit'] text-3xl md:text-5xl font-medium tracking-tight leading-snug">
            International <span className="font-light italic text-amber-100">Outreach</span>
          </h2>

          {/* Light Body Text */}
          <p className="text-sm md:text-base text-white/85 leading-relaxed font-light max-w-2xl">
            Expanding India's economic footprint through strategic partnerships, trade missions, and institutional collaborations across continents.
          </p>

          {/* Subtle Reach Stats Row */}
          <div className="pt-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2.5">
            {reach.map((item) => (
              <div 
                key={item.label}
                className="rounded-lg bg-black/10 backdrop-blur-xs p-2.5 border border-white/10"
              >
                <p className="text-[11px] text-amber-100/80 font-medium uppercase tracking-wider">{item.label}</p>
                <p className="text-sm font-semibold text-white mt-0.5">{item.val}</p>
              </div>
            ))}
          </div>

        </div>
      </div>

      {/* --- GLOBAL PRESENCE COMPONENT --- */}
      <GlobalPresence />

      {/* --- THREE PILLARS CARDS --- */}
      <div className="grid gap-6 md:grid-cols-3">
        {pillars.map((card) => (
          <div 
            key={card.title} 
            className="rounded-2xl bg-white border border-stone-200/80 p-6 shadow-xs hover:shadow-md transition-shadow duration-200 group"
          >
            <div className="mb-4 h-11 w-11 rounded-xl bg-gradient-to-br from-[#DA2128] to-[#DB2628] text-white flex items-center justify-center text-lg shadow-sm shadow-[#DA2128]/20">
              {card.icon}
            </div>
            <h3 className="text-lg font-semibold text-[#1a1a2e] mb-2 font-['Outfit']">{card.title}</h3>
            <p className="text-stone-600 text-xs md:text-sm leading-relaxed">{card.desc}</p>
          </div>
        ))}
      </div>

      {/* --- CLEAN PARTNERS LIST --- */}
      <div className="rounded-2xl bg-stone-50 border border-stone-200/80 p-6 md:p-8">
        <div className="flex items-center gap-2.5 mb-5 pb-3 border-b border-stone-200">
          <FiGlobe className="h-4 w-4 text-[#DB6400]" />
          <h3 className="text-lg font-semibold font-['Outfit'] text-[#1a1a2e]">
            Institutional Alliances & Regional Trade Bodies
          </h3>
        </div>

        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {partners.map((p, idx) => (
            <div 
              key={idx}
              className="p-3.5 rounded-xl bg-white border border-stone-200/80 shadow-2xs"
            >
              <span className="text-[11px] font-bold uppercase tracking-wider text-[#DB6400] block mb-0.5">
                {p.region}
              </span>
              <p className="text-xs md:text-sm font-medium text-stone-700 leading-snug">
                {p.detail.split("—")[1] || p.detail}
              </p>
            </div>
          ))}
        </div>
      </div>

    </section>
  );
}